/**
 * Deprecations for brandy/testimonial-card.
 *
 * WHY THIS FILE EXISTS
 * --------------------
 * v1 built its inner-blocks props with no arguments and rendered them on a
 * second element, so every card saved an attribute-less <div> between the block
 * wrapper and its children. That extra node put the card's layout classes one
 * level above its real children, which is why the Block gap control never did
 * anything. v2 merges the wrapper and the inner blocks onto one element.
 *
 * The entry below reproduces the v1 markup so stored content still validates
 * instead of failing with "this block contains unexpected or invalid content".
 * Attributes and supports are unchanged between the versions, so they are left
 * off here and inherited from the current block type.
 *
 * RULE: never edit a shipped deprecation; add new entries to the FRONT of the
 * array as the block evolves.
 */

import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

/**
 * The v1 save output, copied from the old Content(). Do not tidy it — the empty
 * useInnerBlocksProps.save() call is what produced the bare inner <div>, and the
 * markup has to match the stored HTML structurally.
 *
 * @return {Element} v1 markup.
 */
function V1Save() {
	const blockProps = useBlockProps.save( { className: 'embla__slide' } );
	const innerBlockProps = useInnerBlocksProps.save();

	return (
		<div { ...blockProps }>
			<div { ...innerBlockProps } />
		</div>
	);
}

export default [
	{
		save: V1Save,
	},
];
